import { IDSentenceRecognition } from 'civil-status/constants/id-sentence-recognition';

export const createCondizionatoIdSentenceRecognition1 = (idSentenceRecognition: string): string => {
  if (
    idSentenceRecognition === IDSentenceRecognition.Riconoscimento1 ||
    idSentenceRecognition === IDSentenceRecognition.Riconoscimento3
  ) {
    return 'R13';
  }

  return '';
};

export const createCondizionatoIdSentenceRecognition2 = (idSentenceRecognition: string): string => {
  if (
    idSentenceRecognition === IDSentenceRecognition.Riconoscimento2 ||
    idSentenceRecognition === IDSentenceRecognition.Riconoscimento3
  ) {
    return 'R23';
  }

  return '';
};
